<div class="text-center ml-2 mr-2 item w-100">
    <img src={{item.img}} class="img-cover" />
    <div class="content text-center">
        <div class="name mt-1" routerLink="/item/{{item.slug}}">{{item.name}}</div>
        <div class="description">
            {{item.description}}
        </div>
        <button type="button" class="btn btn-outline-primary pl-5 pr-5" routerLink="/item/{{item.slug}}">Thử</button>
    </div>
</div>